import React from 'react';
import { Field, FormSection } from 'redux-form';

function ContactSection(props) {
  const { sectionName, fieldComponent } = props;

  return (
    <FormSection
      name={sectionName}
    >
      <Field
        label="Phone"
        name="phones"
        placeholder="Phone Numbers"
        component={fieldComponent}
      />
      <Field
        label="Email"
        name="emails"
        placeholder="Email Addresses"
        component={fieldComponent}
      />
      <Field
        label="Website"
        name="websites"
        placeholder="Websites"
        component={fieldComponent}
      />
    </FormSection>
  );
}

export default ContactSection;



// WEBPACK FOOTER //
// ./src/views/products/form-sections/ContactSection.jsx